import React from 'react'
import { useAppSelector, useAppDispatch } from '../../hooks/redux'
import { Route, useHistory, useRouteMatch } from 'react-router'

import Documents from '../../pages/Documents'

import { Routes } from '..'
import { selectArticle } from '../../slices/article'

const DocumentsRoute = () => {
  const dispatch = useAppDispatch()
  const { path, params } = useRouteMatch<{ id: string }>()
  const history = useHistory()

  const { loaded, selected } = useAppSelector(state => state.article)

  const id = React.useMemo(() => params.id, [params])
  const [canMove, setCanMove] = React.useState(false)

  React.useEffect(() => {
    if (!loaded) {
      return
    }

    if (id) {
      dispatch(selectArticle(id))
    } else {
      dispatch(selectArticle(null))
    }
  }, [loaded, id, dispatch])

  React.useEffect(() => {
    setCanMove(true)
  }, [selected])

  React.useEffect(() => {
    return () => {
      dispatch(selectArticle(null))
    }
    //eslint-disable-next-line
  }, [])

  // Updates the url
  React.useEffect(() => {
    if (!loaded || !canMove) {
      return
    }
    setCanMove(false)

    if (selected) {
      if (!window.location.href.endsWith(selected)) {
        history.push(`${Routes.DOCUMENTS}/${selected}`)
      }
    } else {
      history.push(Routes.DOCUMENTS)
    }
  }, [loaded, canMove, selected, history])

  return <Route path={path} component={Documents} />
}

export default DocumentsRoute
